/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * A client team that the freelancer has worked / currently works with
 * @export
 * @interface FreelancerClientTeamResource
 */
export interface FreelancerClientTeamResource {
    /**
     * The ClientTeamId
     * @type {string}
     * @memberof FreelancerClientTeamResource
     */
    id: string;
    /**
     * The client team name
     * @type {string}
     * @memberof FreelancerClientTeamResource
     */
    name?: string;
}

/**
 * Check if a given object implements the FreelancerClientTeamResource interface.
 */
export function instanceOfFreelancerClientTeamResource(value: object): value is FreelancerClientTeamResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function FreelancerClientTeamResourceFromJSON(json: any): FreelancerClientTeamResource {
    return FreelancerClientTeamResourceFromJSONTyped(json, false);
}

export function FreelancerClientTeamResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerClientTeamResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function FreelancerClientTeamResourceToJSON(value?: FreelancerClientTeamResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

